import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import IconButtonNonReact from '../components/IconButtonNonReact';
import Urls from '../urls/Urls';
import UrlHelper from '../core/UrlHelper';
import PlotStatus from '../site/PlotStatus';
import AssetsManager from '../assets_management/AssetsManager';
import HouseTypesViewerEntryStatusesEntry from './HouseTypesViewerEntryStatusesEntry';
import Star from '../components/Star';
export default class HouseTypesViewerEntryStatuses {
	constructor({houseTypes}){
		this._houseTypes = houseTypes;
		this._element = document.createElement('div');
		this._element.classList.add('statuses');
		this._entries = [];
		let plotsToConsider =[];
		houseTypes.forEach(houseType=>plotsToConsider = plotsToConsider.concat(houseType.plots));
		PlotStatus.getValues().forEach(plotStatus=>{
			const entry = new HouseTypesViewerEntryStatusesEntry({plotsToConsider, plotStatus});
			this._entries.push(entry);
			this._element.appendChild(entry.element);
		});
		this._update();
	}
	_update(){
		this._entries.forEach(entry=>entry.update());
	}
	get element(){
		return this._element;
	}
}
